import 十二指腸 from '../img/message/12指腸_メッセージ.png'
import 十三bird from '../img/message/13bird_メッセージ.png'
import atforce from '../img/message/atforce_メッセージ.png'
import Cynops from '../img/message/Cynops_メッセージ.png'
import DesperateSkeleton from '../img/message/DesperateSkeleton_メッセージ.png'
import Hikomuro from '../img/message/Hikomuro_メッセージ.png'
import KYO from '../img/message/KYO_メッセージ.png'
import Niharu from '../img/message/Niharu_メッセージ.png'
import YAS from '../img/message/YAS_メッセージ.png'
import アイスコーラ from '../img/message/アイスコーラ_メッセージ.png'
import アウラ from '../img/message/アウラ_メッセージ.png'
import あませみはり from '../img/message/あませみはり_メッセージ.png'
import アリス from '../img/message/アリス_メッセージ.png'
import イブンバットゥータ from '../img/message/イブン・バットゥータ_メッセージ.png'
import おしぼり from '../img/message/おしぼり_メッセージ.png'
import オノリ from '../img/message/オノリ_メッセージ.png'
import からあげステーキハンバーグ定食 from '../img/message/からあげステーキハンバーグ定食_メッセージ.png'
import きま from '../img/message/きま_メッセージ.png'
import キリシマ from '../img/message/キリシマ_メッセージ.png'
import きりん from '../img/message/きりん_メッセージ.png'
import くらや from '../img/message/くらや_メッセージ.png'
import げつΩ from '../img/message/げつΩ_メッセージ.png'
import こぶりん from '../img/message/こぶりん_メッセージ.png'
import ごりちゃん from '../img/message/ごりちゃん_メッセージ.png'
import サーモン from '../img/message/サーモン_メッセージ.png'
import ざわざわ from '../img/message/ざわざわ_メッセージ.png'
import しゃふの植杉 from '../img/message/しゃふの植杉_メッセージ.png'
import スターゲイザー斬雪 from '../img/message/スターゲイザー斬雪_メッセージ.png'
import スミス from '../img/message/スミス_メッセージ.png'
import タクまんじゅうの天ぷら from '../img/message/タクまんじゅうの天ぷら_メッセージ.png'
import たまきゅー from '../img/message/たまきゅー_メッセージ.png'
import ちなり from '../img/message/ちなり_メッセージ.png'
import ちょり from '../img/message/ちょり_メッセージ.png'
import ちわわん皇帝 from '../img/message/ちわわん皇帝_メッセージ.png'
import テリオス from '../img/message/テリオス_メッセージ.png'
import とりこえインコ from '../img/message/とりこえインコ_メッセージ.png'
import なおけさ from '../img/message/なおけさ_メッセージ.png'
import なごみみかん from '../img/message/なごみみかん_メッセージ.png'
import ぬべ from '../img/message/ぬべ_メッセージ.png'
import ひのえ from '../img/message/ひのえ_メッセージ.png'
import ピポモリナガ from '../img/message/ピポモリナガ_メッセージ.png'
import ヒルケン from '../img/message/ヒルケン_メッセージ.png'
import ヒロ from '../img/message/ヒロ_メッセージ.png'
import ぷっちょ from '../img/message/ぷっちょ_メッセージ.png'
import ブラボー和尚 from '../img/message/ブラボー和尚_メッセージ.png'
import ホクロ from '../img/message/ホクロ_メッセージ.png'
import まおれー from '../img/message/まおれー_メッセージ.png'
import マグロ from '../img/message/マグロ_メッセージ.png'
import もてぃお from '../img/message/もてぃお_メッセージ.png'
import やっしゅ from '../img/message/やっしゅ_メッセージ.png'
import ゆきんこ from '../img/message/ゆきんこ_メッセージ.png'
import ユッキー from '../img/message/ユッキー_メッセージ.png'
import よりしろ from '../img/message/よりしろ_メッセージ.png'
import らぴす from '../img/message/らぴす_メッセージ.png'
import りく from '../img/message/りく_メッセージ.png'
import リュウ from '../img/message/リュウ_メッセージ.png'
import 浦丹羽自由 from '../img/message/浦丹羽自由_メッセージ.png'
import 永劫回帰 from '../img/message/永劫回帰_メッセージ.png'
import 夏影なお from '../img/message/夏影なお_メッセージ.png'
import 暇人のへちま from '../img/message/暇人のへちま_メッセージ.png'
import 海風マサナ from '../img/message/海風マサナ_メッセージ.png'
import 犬神じゅしわん from '../img/message/犬神じゅしわん_メッセージ.png'
import 賢宮瑞希 from '../img/message/賢宮瑞希_メッセージ.png'
import 山内ナッツ from '../img/message/山内ナッツ_メッセージ.png'
import 紫水 from '../img/message/紫水_メッセージ.png'
import 趣味優先人 from '../img/message/趣味優先人_メッセージ.png'
import 西蓮寺 from '../img/message/西蓮寺_メッセージ.png'
import 石黒蒼斗 from '../img/message/石黒蒼斗_メッセージ.png'
import 草彅健太 from '../img/message/草彅健太_メッセージ.png'
import 蒼井セラ from '../img/message/蒼井セラ_メッセージ.png'
import 地平線が食パン from '../img/message/地平線が食パン_メッセージ.png'
import 不倶戴天 from '../img/message/不倶戴天†ふぐたいてん†のフグ田_メッセージ.png'
import 不知火エンキ from '../img/message/不知火エンキ_メッセージ.png'
import 野菜とお肉 from '../img/message/野菜とお肉_メッセージ.png'
import 侑サブろぽーと from '../img/message/侑サブろぽーと_メッセージ.png'

function msglist() {
  const msgImage = [
    十二指腸,
    十三bird,
    atforce,
    Cynops,
    DesperateSkeleton,
    Hikomuro,
    KYO,
    Niharu,
    YAS,
    アイスコーラ,
    アウラ,
    あませみはり,
    アリス,
    イブンバットゥータ,
    おしぼり,
    オノリ,
    からあげステーキハンバーグ定食,
    きま,
    キリシマ,
    きりん,
    くらや,
    げつΩ,
    こぶりん,
    ごりちゃん,
    サーモン,
    ざわざわ,
    しゃふの植杉,
    スターゲイザー斬雪,
    スミス,
    タクまんじゅうの天ぷら,
    たまきゅー,
    ちなり,
    ちょり,
    ちわわん皇帝,
    テリオス,
    とりこえインコ,
    なおけさ,
    なごみみかん,
    ぬべ,
    ひのえ,
    ピポモリナガ,
    ヒルケン,
    ヒロ,
    ぷっちょ,
    ブラボー和尚,
    ホクロ,
    まおれー,
    マグロ,
    もてぃお,
    やっしゅ,
    ゆきんこ,
    ユッキー,
    よりしろ,
    らぴす,
    りく,
    リュウ,
    浦丹羽自由,
    永劫回帰,
    夏影なお,
    暇人のへちま,
    海風マサナ,
    犬神じゅしわん,
    賢宮瑞希,
    山内ナッツ,
    紫水,
    趣味優先人,
    西蓮寺,
    石黒蒼斗,
    草彅健太,
    蒼井セラ,
    地平線が食パン,
    不倶戴天,
    不知火エンキ,
    野菜とお肉,
    侑サブろぽーと,
  ]
  return msgImage
}
export default msglist
